import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Container, makeStyles } from '@material-ui/core';

import { t } from 'src/shared/literals';
import Page from 'src/shared/ui/components/Page';
import Datatable from 'src/shared/ui/components/Datatable';

import getHeadquarterContractList from 'src/contract/use-cases/getHeadquarterContractList';
import downloadHeadquarterContractListExcel from 'src/contract/use-cases/downloadHeadquarterContractListExcel';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const HeadquarterContractListView = () => {
  const classes = useStyles();

  const companyHeadquarterId = localStorage.selectedUserHeadquarter;

  const user = JSON.parse(localStorage.user);

  const [list, setList] = useState({
    rows: [],
    count: 0
  });
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [orderBy, setOrderBy] = useState({
    columnName: null,
    orderBy: null
  });

  const navigate = useNavigate();

  async function fetchList() {
    const response = await getHeadquarterContractList({
      companyHeadquarterId,
      search,
      orderBy: orderBy.columnName
        ? `${orderBy.columnName} ${orderBy.orderBy}`
        : '',
      page,
      limit
    });

    response.rows = response.rows.map((x) => {
      let MoneyCollectionCustomerContactPaymentTypeList = {
        MoneyCollectionCustomerContactPaymentTypeList: x
          .MoneyCollectionCustomerContact.PaymentTypeList
          ? x.MoneyCollectionCustomerContact.PaymentTypeList.map((y) =>
              t(y.toLowerCase()).toUpperCase()
            ).join(',')
          : ''
      };

      return {
        ...x,
        ...MoneyCollectionCustomerContactPaymentTypeList
      };
    });

    setList(response);
  }

  useEffect(() => {
    fetchList();
  }, [page, limit, search, orderBy]);

  const handleSearch = (searchValue) => {
    setPage(0);
    setSearch(searchValue.target.value);
  };

  const handleChangePage = (pageIndex) => {
    setPage(pageIndex);
  };

  const handleChangeLimit = (limitIndex) => {
    setLimit(limitIndex);
  };

  const handleOrderBy = (column) => {
    setOrderBy(column);
  };

  const handleClickEdit = (event, id) => {
    navigate(`/app/contracts/${id}`, {
      replace: false
    });
  };

  const handleClickExportExcel = () => {
    downloadHeadquarterContractListExcel({ companyHeadquarterId });
  };

  const columnNameList = [
    'createdAt',
    'updatedAt',
    'ContractStatus.code',
    'hasPendingDocuments',
    '${contractCodePrefix}${contractCode}',
    "${'CL'}${HeadquarterCustomer.customerCode}",
    'HeadquarterCustomer.businessName,LINK:/app/customers/:headquarterCustomerId',
    'billToCustomerContactDocument',
    'MoneyCollectionCustomerContact.document',
    'MoneyCollectionCustomerContactPaymentTypeList',
    '${Seller.firstname}${Seller.surnames}',
    'contractTypeSellerComission',
    'contractTypeReferralComission',
    'UnmanagedSignaturePenaltyFee',
    'ContractType.name',
    'itemName',
    'identification',
    'document',
    'beginDate',
    'renewalDate',
    '${UserCreator.firstname}${UserCreator.surnames}',
    'comments'
  ];

  if (localStorage.selectedUserHeadquarter === 'all') {
    columnNameList.unshift('CompanyHeadquarter.name');
  }

  return (
    <Page className={classes.root} title="Contratos">
      <Container maxWidth={false}>
        <Datatable
          domainName="HEADQUARTER_CONTRACT"
          title="Contratos"
          dataList={list.rows}
          count={list.count}
          exportExcelButton={user?.scopes.includes('admin:contracts')}
          handleClickExportExcel={handleClickExportExcel}
          onSearch={handleSearch}
          onChangePageValue={handleChangePage}
          onChangePageLimit={handleChangeLimit}
          handleOrderBy={handleOrderBy}
          handleClickEdit={handleClickEdit}
          columnNameList={columnNameList}
        />
      </Container>
    </Page>
  );
};

export default HeadquarterContractListView;
